<form nz-form class="mr-2" autocomplete="off">
	<div class="title-30 color-blue">
		{{ "global.org_settings.general.title" | translate }}
	</div>
	<div class="subtitle-30 color-grey">
		{{ "global.org_settings.general.subtitle" | translate }}
	</div>
	<div [formGroup]="formGroup">

		<div nz-row>
			<div nz-col nzSpan="12">
				<nz-descriptions>
					<nz-descriptions-item nzTitle="ID">{{organization.id}}</nz-descriptions-item>
				</nz-descriptions>

				<nz-form-item class="input-field">
					<nz-form-control>
						<app-input-field [form]="formGroup" [label]="'global.common.website' | translate"
							[placeholder]="''" [formName]="'website'" [size]="'large'">
						</app-input-field>
					</nz-form-control>
				</nz-form-item>

				<nz-form-item class="input-field">
					<nz-form-control>
						<app-input-field [form]="formGroup"
							[label]="'global.common.commercial_register_number' | translate" [placeholder]="''"
							[formName]="'commercialRegisterNumber'" [size]="'large'">
						</app-input-field>
					</nz-form-control>
				</nz-form-item>

				<nz-form-item class="input-field">
					<nz-form-control>
						<app-input-field [form]="formGroup" [label]="'global.common.email' | translate"
							[placeholder]="''" [formName]="'email'" [size]="'large'">
						</app-input-field>
					</nz-form-control>
				</nz-form-item>
			</div>

			<div nz-col nzSpan="10" nzOffset="2">
				<div class="center mb-1">
					<label class="font-600">{{ "global.common.organization_picture" | translate }}</label>
				</div>

				<div class="center mb-1">
					<div *ngIf="profileUrl.length && !updatedProfilePicture && !previewImage">
						<app-image-with-loading width="250" height="250" [productImages]="profileUrl" [index]="0" [isProfile]="true">
						</app-image-with-loading>
					</div>
					<div *ngIf="!profileUrl.length && updatedProfilePicture && previewImage">
						<img [src]="previewImage" class="image" height="250" width="250" />
					</div>
				</div>


				<nz-modal [(nzVisible)]="isUploadProfilePictureModalVisible" nzCentered
					(nzOnCancel)="closeUploadProfilePictureModal()"
					[nzTitle]="'global.common.upload_limit_modal.title' | translate">

					<ng-container *nzModalContent>
						<div class="text-center">
							<nz-upload [(nzFileList)]="profilePictureList" [nzBeforeUpload]="beforeUpload"
								[nzMultiple]="false" [nzLimit]="1" class="custom-file-upload"
								nzAccept="image/png, image/jpeg, image/jpg" [nzRemove]="handleRemoveUploaded">
								<div>
									<button [disabled]="profilePictureList.length === 1" nz-button nzSize="large"
										class="add-button border-radius-5 color-blue border-color-blue">
										{{'global.supplier.products.modals.button.open_file' | translate}}
									</button><br>
								</div>
							</nz-upload>
							<div class="mt-0_5 center text-danger" *ngIf="fileTypeError">{{ "global.common.invalid_format" | translate }}</div>
							<div class="mt-0_5 center text-danger" *ngIf="fileSizeError">{{ "global.common.invalid_size" | translate }}</div>
						</div>
					</ng-container>
					<div *nzModalFooter>
						<button [disabled]="fileTypeError || fileSizeError" class="bg-color-blue color-white border-radius-5" nz-button
							(click)="updateProfilePicture()">
							{{ "global.common.update_picture" | translate }}
						</button>
					</div>
				</nz-modal>


				<div class="center mb-1">
					<button *ngIf="!profileUrl.length && !profilePictureList.length" nz-button class="color-blue border-color-blue border-radius-5 mr-1"
						(click)="openUploadProfilePictureModal()">
						<i nz-icon nzType="plus"></i>
						{{ "global.common.upload_picture" | translate }}
					</button>
					<button *ngIf="profileUrl.length || profilePictureList.length" nz-button class="color-blue border-color-blue border-radius-5 mr-1"
						(click)="openUploadProfilePictureModal()">
						<i nz-icon nzType="plus"></i>
						{{ "global.common.change_picture" | translate }}
					</button>
					<button nz-button class="btn-danger border-radius-5" [disabled]="!profileUrl.length && !profilePictureList.length"
						(click)="removeImage()">
						<i nz-icon nzType="delete"></i>
						{{ "global.common.remove_picture" | translate }}
					</button>
				</div>
			</div>
		</div>

		<nz-form-item class="input-field">
			<nz-form-control>
				<nz-form-label nzFor="description">{{ 'global.common.about_company' | translate}}
				</nz-form-label>
				<nz-textarea-count [nzMaxCharacterCount]="maxDescription">
					<textarea [nzAutosize]="{ minRows: 5, maxRows: 10 }" formControlName="description"
						nz-input></textarea>
				</nz-textarea-count>
				<app-validation-errors
					*ngIf=" (formGroup?.controls['description'].touched || formGroup?.controls['description'].dirty)"
					[errors]="formGroup?.get('description').errors" label="description">
				</app-validation-errors>
			</nz-form-control>
		</nz-form-item>
		<nz-form-item class="input-field">
			<nz-form-control>
				<app-input-field [form]="formGroup" [label]="'global.common.vat' | translate" [placeholder]="''"
					[formName]="'vat'" [size]="'large'">
				</app-input-field>
			</nz-form-control>
		</nz-form-item>
		<nz-form-item class="input-field">
			<nz-form-control>
				<app-users-list (primaryContactEvent)="selectPrimaryContact($event)"></app-users-list>
			</nz-form-control>
		</nz-form-item>

        <div *ngIf="organization.type === 'buyer'">
		<nz-form-item class="input-field">
			<nz-form-control>
				<app-input-field [size]="'large'"
					[form]="formGroup"
					[placeholder]="''"
					[formName]="'paymentTerms'"
					[label]="('global.buyer.new_tender.payment.payment_info_1' | translate)">
				</app-input-field>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-control>
				<app-input-field [size]="'large'" [form]="formGroup"
					[placeholder]="''"
					[label]="('global.buyer.new_tender.payment.payment_info_2' | translate)"
					[formName]="'deliveryTerms'">
				</app-input-field>
			</nz-form-control>
		</nz-form-item>
		</div>

		<nz-form-item class="input-field">
			<nz-form-control>
				<app-input-field [form]="formGroup" [label]="'global.common.terms_and_conditions' | translate"
					[placeholder]="''" [formName]="'termsAndConditions'" [size]="'large'">
				</app-input-field>
			</nz-form-control>
		</nz-form-item>

		<div nz-row nzAlign="middle" nzJustify="start" *appUserRole="'organization_settings_general_edit'">
			<div nz-col class="gutter-row">
				<button nz-button [disabled]="this.formGroup.invalid || fileSizeError"
					class="border-color-blue color-blue border-radius-5"
					(click)="updateProfileInformation()">{{'global.profile_settings.profile.buttons.save' |
					translate}}</button>
			</div>
		</div>
	</div>
</form>
